export default "__VITE_ASSET__4oQqQZbt__"